export const validRegions = ["EUOU", "EMEOU", "AOU", "NAOU", "LATAM", "APAC"];
